import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import VisibilityBox from '../common/visibility-box/VisibilityBox';
import { LANG } from '../../../constants/language';

interface Team{
  team: any,
  users: any[]
}
interface Props{
    participants:any[],
    teams: Team[],
}
const EventParticipants = ({participants, teams}:Props) => {
  const [peoples, setPeoples]= useState<any[]>([]);
  const [userStatus, setUserStatus]=useState<any[]>([]);
  const [userReason, setUserReason]=useState<any[]>([]);

  useEffect(()=>{
    let status:any={};
    let reason:any={};
    let latestPeoples= [
        ...participants.map((p:any)=>{
           status[p.user._id]= p?.status;
           reason[p.user._id]= p?.reason;
           return p?.user;
        }),
    ];
    for(let team of teams){
      latestPeoples=latestPeoples.concat(team?.users.map(
        (p:any)=>{
          status[p?.user?._id]= p?.status;
          reason[p.user._id]= p?.reason;
          return p?.user;
        }
      ));
    }
    latestPeoples=_.uniqBy(latestPeoples,"_id");
    setPeoples(latestPeoples);
    setUserStatus(status);
    setUserReason(reason);
  },[participants, teams]);


  return (
    <div className='my-4'>
        <h5>Members Acceptance</h5>
        {
            peoples?.map((p,i)=>(
                <div key={i}>
                   {i+1}. <span className='text-capitalize'>{p?.firstName} {p?.lastName}</span>
                   <span className='mx-4 text-capitalize fw-bold'>- {userStatus[p?._id]}</span>
                   <VisibilityBox show={userStatus[p?._id]==='rejected'}>
                      <p ><span>{LANG.REASON}: </span><span className='text-warning'> {userReason[p?._id]}</span></p>
                   </VisibilityBox>
                </div>
            ))  || 'No participants'
        }
    </div>
  )
}

export default EventParticipants